<template>
  <div class="header-menus">
    <a-menu v-model:selectedKeys="selectedKeys" mode="horizontal">
      <template v-for="(item, index) in menus" :key="index">
        <a-sub-menu
          v-if="item.children && item.children.length > 1"
          @click="clickHandle(item)"
          :key="item.fullPath"
        >
          <div class="no-ability-msg" v-if="notInScope()">
            <ExclamationCircleFilled class="err-msg-icon" />
            {{ $t('user.Your are not in the eligible scope of this round.') }}
          </div>
          <div class="no-ability-msg" v-else-if="hasExpired()">
            <ExclamationCircleFilled class="err-msg-icon" />
              {{ $t('user.The Project ROAR open window is closed.') }}
          </div>
          <template #title>
            {{ $t('user.' + item.meta.title) }}
            <svg-icon
              icon-class="caret-down"
              class="sub-menu-icon"
              style="font-size: 10px"
            />
          </template>
          <a-menu-item
            v-for="subItem in item.children"
            :key="subItem.fullPath"
            @click="clickHandle(subItem)"
            :disabled="isDisabledRoute(subItem)"
          >
            <div class="menu-title">
              <svg-icon
                v-if="subItem.meta.icon"
                class="menu-icon"
                :icon-class="subItem.meta.icon"
              ></svg-icon>
              {{ $t('user.' + subItem.meta.title) }}
            </div>
            <CheckOutlined v-if="selectedKeys.indexOf(subItem.fullPath) > -1" />
          </a-menu-item>
        </a-sub-menu>
        <a-menu-item v-else @click="clickHandle(item)" :key="item.fullPath">
          {{ $t('user.' + item.meta.title) }}
        </a-menu-item>

        <a-menu-item class="menu-splite" v-if="index + 1 != menus.length">
          <div class="splite-box"></div>
        </a-menu-item>
      </template>
    </a-menu>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { CheckOutlined, ExclamationCircleFilled } from '@ant-design/icons-vue'

  export default {
    name: 'PrMenu',
    data() {
      return {
        selectedKeys: [],
        openKeys: [],
      }
    },
    components: { CheckOutlined, ExclamationCircleFilled },
    computed: {
      ...mapGetters({
        menus: 'routes/menus',
        ability: 'acl/ability',
        applicationPeriod: 'user/applicationPeriod',
        offlineMode: 'user/offlineMode',
      }),
    },
    watch: {
      $route: {
        handler({ path, matched }) {
          if (matched && matched.length > 0) {
            matched[0]?.children.length > 1
              ? (this.selectedKeys = [path])
              : (this.selectedKeys = [matched[0].path])
            this.openKeys = [matched[0].path]
          } else {
            console.log('ROUTE ERR.')
          }
        },
        immediate: true,
      },
    },
    methods: {
      notInScope() {
        return !this.hasAbility('in_scope')
      },
      hasExpired() {
        return !this.hasAbility('apply')
      },
      hasAbility(key) {
        const ability = this.ability.find((item) => item.key === key)
        if (ability == null) {
          console.log('getAbility', ability)
        }
        return ability != null && ability.value
      },
      isDisabledRoute(menu) {
        if (menu.name === 'My Application' || menu.name === 'Me') {
          return !this.hasAbility('check_history')
        } else if (menu.name === 'Apply For ROAR Moment') {
          return !this.hasAbility('apply') || this.offlineMode
        } else {
          return false
        }
      },
      clickHandle(route) {
        const { fullPath } = route
        if (!this.isDisabledRoute(route)) {
          this.$router.push({ path: fullPath })
        }
      },
    },
  }
</script>

<style lang="less">
  @import url('@/styles/params.less');
  .header-menus {
    width: 100%;
    height: 30px;
    background-color: black;
    color: white;
    .ant-menu {
      border: none;
      .ant-menu-item,
      .ant-menu-submenu {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-weight: bold;
        padding: 0 !important;
        margin: 0 6px;
        &::after {
          border-width: 1px;
          width: 100%;
          left: 0;
          right: 0;
        }
      }
      .ant-menu-title-content {
        justify-content: space-between;
      }

      .menu-splite {
        .splite-box {
          width: 1px;
          height: 14px;
          background: #999;
          position: absolute;
          top: 50%;
          margin-top: -8px;
        }
        &::after {
          display: none;
        }
      }

      background-color: black;
      color: white;
    }
    // height: 100%;
  }
  .ant-menu-title-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    line-height: 24px;
  }
  .ant-menu-submenu-popup {
    .ant-menu-item {
      min-height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .sub-menu-icon {
    margin-left: 8px;
  }
  .menu-title {
    display: flex;
    align-items: center;
    min-width: 240px;
    color: #333;
  }
  .menu-icon {
    font-size: 24px;
    margin-right: 10px;
    color: #666;
  }
  .ant-menu-item-selected {
    .menu-icon,
    .menu-title {
      color: @primary-color;
    }
  }
  .ant-menu-item-disabled {
    .menu-icon {
      color: #ccc;
    }
    .menu-title {
      color: #999;
    }
  }
  .no-ability-msg {
    height: 64px;
    display: flex;
    align-items: center;
    padding: 12px 14px 12px 14px;
    width: 287px;
    line-height: 1.2em;
    font-size: 16px;
    color: #333333;
    background-color: #fbf5ec;
    .err-msg-icon {
      font-size: 24px;
      color: #faba16;
      margin-right: 10px;
    }
  }
</style>
